import * as yup from "yup";
import {
  testFloat,
  testPositiveFloat,
  testPositiveFloatInclusiveZero,
} from "../../../../utilities/form-validation";

export const schema = yup.object().shape({
  id: yup.string().optional(),
  locationId: yup.string().when("id", {
    is: (id: string) => !id,
    then: yup.string().required(),
    otherwise: yup.string(),
  }),
  supplierId: yup.string().when("id", {
    is: (id: string) => !id,
    then: yup.string().required(),
    otherwise: yup.string(),
  }),
  freightCost: yup
    .string()
    .test("valid-money", "Invalid Value", testFloat as any)
    .test(
      "positive",
      "Quantity must be positive",
      testPositiveFloatInclusiveZero as any
    )
    .optional(),
  invoiceNumber: yup.string().required(),
  orderNumber: yup.string().optional(),
  invoiceDate: yup.date().nullable(),
  invoiceArrivalDate: yup.date().nullable(),
  invoiceDueDate: yup.date().nullable(),
  costPriceIncGST: yup.boolean().optional(),
});
